import "./MoldRemediation.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Overview from "./sections/Overview";
import Process from "./sections/Process";
import WhyChoose from "./sections/WhyChoose";
import Faqs from "./sections/Faqs";
import RequestService from "./sections/RequestService";
import Footer from "@/reusable_sections/Footer";
export default function MoldRemediationPage() {
  return <div>
      <Header />
      <Hero />
      <Overview />
      <Process />
      <WhyChoose />
      <Faqs />
      <RequestService />
      <Footer />
    </div>;
}